/**
 * Cart quantity stepper.
 *
 * The theme's cart is a plain form: change a quantity, press "update cart".
 * With − / + buttons that model breaks down — nobody expects to press a second
 * button to make a plus sign take effect — so a change here submits the form
 * itself, debounced so tapping + three times is one round trip, not three.
 *
 * The number input remains the source of truth. Without JS the buttons do
 * nothing and the field is still typable, which is why they carry tabindex="-1"
 * — keyboard users get the input's own native stepper instead of two extra
 * tab stops that may not work.
 */
(function () {
  var SUBMIT_DELAY_MS = 550;

  function boot() {
    var groups = [].slice.call(document.querySelectorAll('[data-wp-qty]'));
    if (!groups.length) return;

    var form = groups[0].closest('form');
    var updateButton = form ? form.querySelector('[name="update"]') : null;
    if (!form || !updateButton) return;

    var timer = 0;

    function scheduleSubmit() {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        // Click the theme's own update control rather than form.submit(), so
        // the request carries name="update" and Shopify applies the quantities.
        updateButton.click();
      }, SUBMIT_DELAY_MS);
    }

    groups.forEach(function (group) {
      var input = group.querySelector('.quantity-selector');
      if (!input) return;

      group.addEventListener('click', function (evt) {
        var button = evt.target.closest('[data-wp-qty-step]');
        if (!button) return;

        var step = parseInt(button.getAttribute('data-wp-qty-step'), 10);
        var current = parseInt(input.value, 10);
        if (!Number.isFinite(current)) current = 0;

        var next = current + step;
        var min = parseInt(input.getAttribute('min'), 10);
        if (Number.isFinite(min) && next < min) next = min;

        if (next === current) return;
        input.value = String(next);
        group.classList.toggle('is-empty', next === 0);
        scheduleSubmit();
      });

      // Typing into the field should behave the same as pressing the buttons.
      input.addEventListener('change', scheduleSubmit);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
